var ContactPage = function () {

    return {
        
    	//Basic Map
        initMap: function () {
            var map;
            $(document).ready(function () {
                map = new GMaps({
                    div: '#map',
                    scrollwheel: false,
                    lat: 53.3450651,
                    lng: -2.6394394,
                    zoom: 13
                });

                var marker = map.addMarker({
                    lat: 53.3450651,
                    lng: -2.6394394,
                    title: '360 Systems Ltd',
                    infoWindow: {
                        content: '<div>' +
                            '<strong>360 Systems Limited</strong> <br/>' +
                            'The Innovation Centre,<br/>' +
                            'Sci-Tech Daresbury, Warrington WA4 4FS <br/>' +
                            'Phone: 0151 355 7911' +
                            '</div>'
                    }
                });
            });
        },

        //Panorama Map
        initPanorama: function () {
		    var panorama;
		    $(document).ready(function(){
		      panorama = GMaps.createPanorama({
		        el: '#panorama',
                  lat: 53.3450651,
                  lng: -2.6394394
		      });
		    });
		}        

    };
}();